export const sponsoredBlogPosts = [
  {
    id: 'sponsored-1',
    title: 'Discover Wellness at Serenity Spa & Wellness Center',
    category: 'Health & Wellness',
    excerpt: 'Experience the ultimate relaxation and rejuvenation at Roseville\'s premier wellness destination, offering massage therapy, facials, and holistic treatments.',
    readTime: '4 Min Read',
    date: 'March 18, 2025',
    author: 'Roseville.org Partner',
    image: 'https://public.readdy.ai/ai/img_res/8b1ff37b1c94b3990efa2909d9d48821.jpg',
    isSponsored: true,
    sponsor: {
      name: 'Serenity Spa & Wellness',
      logo: 'https://readdy.ai/api/search-image?query=Modern%20elegant%20spa%20wellness%20logo%20design%20with%20lotus%20flower%20symbol%2C%20minimalist%20clean%20aesthetic%2C%20teal%20and%20gold%20colors%2C%20professional%20wellness%20brand%20identity&width=200&height=200&seq=sponsorlogo01&orientation=squarish'
    }
  }
];

export const sponsoredNewsletterAds = [
  {
    id: 'newsletter-sponsor-1',
    businessName: 'Roseville Auto Group',
    logo: 'https://readdy.ai/api/search-image?query=Professional%20automotive%20dealership%20logo%20design%20with%20modern%20car%20silhouette%2C%20bold%20typography%2C%20red%20and%20black%20colors%2C%20trusted%20car%20dealer%20brand&width=300&height=150&seq=newsletterlogo01&orientation=landscape',
    headline: 'Spring Sales Event - Save Up to $5,000',
    description: 'Visit Roseville Auto Group this month for incredible savings on new and certified pre-owned vehicles. Family-owned and serving the community since 1985.',
    ctaText: 'View Inventory',
    ctaLink: 'https://rosevilleautogroup.com',
    weekOf: 'March 17, 2025'
  },
  {
    id: 'newsletter-sponsor-2',
    businessName: 'Harvest Kitchen & Bar',
    logo: 'https://readdy.ai/api/search-image?query=Farm%20to%20table%20restaurant%20logo%20with%20wheat%20stalks%20and%20fork%20design%2C%20rustic%20elegant%20style%2C%20green%20and%20brown%20earth%20tones%2C%20organic%20dining%20brand&width=300&height=150&seq=newsletterlogo02&orientation=landscape',
    headline: 'New Spring Menu Now Available',
    description: 'Experience farm-to-fork dining at its finest with our seasonal spring menu featuring locally-sourced ingredients and craft cocktails.',
    ctaText: 'Make Reservation',
    ctaLink: 'https://harvestkitchen.com',
    weekOf: 'March 10, 2025'
  }
];

export const homepageSpotlightBusinesses = [
  {
    id: 'spotlight-featured-1',
    name: 'Peak Performance Fitness',
    tagline: 'Transform Your Life, One Workout at a Time',
    category: 'Fitness & Wellness',
    description: 'State-of-the-art fitness facility offering personal training, group classes, and cutting-edge equipment. Join our community of over 2,000 members achieving their fitness goals.',
    image: 'https://readdy.ai/api/search-image?query=Modern%20upscale%20fitness%20gym%20interior%20with%20high-end%20equipment%2C%20bright%20natural%20lighting%2C%20clean%20contemporary%20design%2C%20motivated%20people%20working%20out%2C%20premium%20health%20club%20atmosphere&width=1200&height=600&seq=spotlightbiz01&orientation=landscape',
    rating: 4.9,
    reviewCount: 487,
    priceRange: '$$',
    address: '1250 Galleria Blvd, Roseville, CA 95678',
    phone: '(916) 555-0199',
    hours: 'Mon-Fri 5am-10pm, Sat-Sun 7am-8pm',
    website: 'https://peakperformanceroseville.com',
    highlights: [
      '24/7 Member Access',
      'Personal Training',
      'Group Classes',
      'Spa & Sauna',
      'Childcare Available'
    ],
    reviews: [
      { author: 'Jessica T.', text: 'Best gym in Roseville by far! The equipment is always clean and the trainers are incredibly motivating.', rating: 5, date: '1 week ago' },
      { author: 'Marcus L.', text: 'Joined 6 months ago and already hit my fitness goals. The group classes are so much fun and the community is amazing.', rating: 5, date: '2 weeks ago' },
    ],
    isSponsored: true,
    sponsorshipWeek: 'March 17-23, 2025',
    badge: 'Featured This Week',
    badgeColor: 'violet'
  }
];